import { I18n, Amplify, Auth, Hub } from "aws-amplify";
import React, { useState } from "react";
import { cognitoUserInfo } from "../../helpers/userHelper";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import { Authenticator, View, translations, useAuthenticator, useTheme } from "@aws-amplify/ui-react";

import "@aws-amplify/ui-react/styles.css";
import awsmobile from "../../configs/aws-exports";
import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";
import { decode as base64_decode } from "base-64";
import { PROVIDER } from "../../helpers/variableHelper";
import { useLocalStorage } from "@uidotdev/usehooks";

I18n.putVocabularies(translations);
I18n.setLanguage("es");

I18n.putVocabularies({
  es: {
    "Sign In": "Registrarse",
    "Sign Up": "Regístrate",
  },
});
Amplify.configure({
  Auth: awsmobile,
});

const htmlLogin = (email: string, lastURl: string) => {
  return (
    <View textAlign="center">
      <h6 className="mt-3 colorTit" hidden={email === "" ? false : true}>
        Debes iniciar sesión para acceder a este contenido
      </h6>

      <Button
        color="primary"
        className="mt-3 btn-lg mx-auto"
        type="submit"
        data-testid="test1"
        onClick={() => Auth.federatedSignIn({ customProvider: PROVIDER, customState: JSON.stringify(lastURl) })}>
        Iniciar sesión con su cuenta transelec
      </Button>
      <p className="mt-3 border border-1 text-primary"></p>
      <p className="mt-3 colorTit">
        <small>O inicie sesión con su cuenta externa, ingresando correo y contraseña.</small>
      </p>
    </View>
  );
};

const header = () => {
  return <h3 className="colorTitVerde">Recuperar Contraseña</h3>;
};

const headerConfirm = () => {
  return (
    <div>
      <h3 className="colorTitVerde">Ingresa nueva contraseña</h3>
      <p>Se debe cambiar en el primer inicio de sesión</p>
    </div>
  );
};
const Login = () => {
  useTheme();

  let search = new URLSearchParams(window.location.search);
  const lastURl = search.get("last") ?? window.location.origin;
  const [email, setEmail] = useState("");
  const [redirectUrlLogin, saveRedirectUrlLogin] = useLocalStorage<string>("redirectUrlLogin", "/");

  const userInfo = cognitoUserInfo();

  React.useEffect(() => {
    if (email) {
      window.location.href = redirectUrlLogin;
      saveRedirectUrlLogin("/");
    }
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          window.location.href = redirectUrlLogin;
          saveRedirectUrlLogin("/");
          break;
        case "customOAuthState":
          let url = JSON.parse(data);
          if (!url) {
            console.log("No hay url de redirección");
            window.location.href = redirectUrlLogin;
            saveRedirectUrlLogin("/");
          }
          window.location.href = base64_decode(url);
          break;
        default:
          break;
      }
    });

    (async () => {
      userInfo.then((user) => {
        setEmail(user.email);
      });
    })();
    getUser();
  }, [email]);
  const getUser = async (): Promise<void> => {
    try {
      const userData = await Auth.currentAuthenticatedUser();
    } catch (error) {
      console.log("Not signed in");
    }
  };

  const formFields = {
    signIn: {
      username: {
        placeholder: "Ingrese su email",
      },
    },
    signUp: {
      password: {
        label: "Password:",
        placeholder: "Ingrese su contraseña:",
        isRequired: false,
        order: 2,
      },
      confirm_password: {
        label: "Confirme su contraseña:",
        placeholder: "Confirmar Contraseña",
        order: 1,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: "Ingrese su contraseña:",
      },

      confirm_password: {
        label: "Confirme su contraseña:",
        placeholder: "Confirmar Contraseña",
      },
    },
    resetPassword: {
      username: {
        placeholder: "Ingrese su email:",
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        label: "Código de confirmación",
        placeholder: "Ingrese código de confirmación",
        isRequired: false,
      },
      confirm_password: {
        label: "Confirme su contraseña:",
        placeholder: "Confirmar Contraseña",
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: "test issuer",
        totpUsername: "amplify_qr_test_user",
      },
      confirmation_code: {
        label: "Código de confirmación",
        placeholder: "Ingrese código de confirmación",
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: "New Label",
        placeholder: "Enter your Confirmation Code:",
        isRequired: false,
      },
    },
  };

  const components: DefaultComponents = {
    SignIn: {
      Header() {
        useAuthenticator();
        return htmlLogin(email, lastURl);
      },
    },
    ResetPassword: {
      Header() {
        return header();
      },
    },
    ConfirmResetPassword: {
      Header() {
        return header();
      },
    },
    ForceNewPassword: {
      Header() {
        return headerConfirm();
      },
    },
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <Authenticator components={components} hideSignUp={true} formFields={formFields}>
            {({ signOut, user }) => (
              <main>
                <h1>
                  Hola {(user?.attributes as any).given_name} ({user?.attributes?.email})
                </h1>
                <button className="btn btn-primary" onClick={signOut}>
                  Cerrar sesión
                </button>
              </main>
            )}
          </Authenticator>
        </div>
      </div>
    </div>
  );
};

export default Login;
